import { useLayoutEffect } from 'react';

export function useWindowResize(callback: () => void, callOnInit = false) {
    useLayoutEffect(() => {
        if (callOnInit) callback();
        const handleResize = () => callback();

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, [callback, callOnInit]);
}
